import { render, staticRenderFns } from "./QuestionCall.vue?vue&type=template&id=1cdc704b"
import script from "./QuestionCall.vue?vue&type=script&lang=js"
export * from "./QuestionCall.vue?vue&type=script&lang=js"
import style0 from "./QuestionCall.vue?vue&type=style&index=0&id=1cdc704b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports